import { render, staticRenderFns } from "./companyRegister.vue?vue&type=template&id=ff38c608&scoped=true"
import script from "./companyRegister.vue?vue&type=script&lang=js"
export * from "./companyRegister.vue?vue&type=script&lang=js"
import style0 from "./companyRegister.vue?vue&type=style&index=0&id=ff38c608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff38c608",
  null
  
)

export default component.exports